
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type TProductcronjobsState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        loading: boolean,
        sortBy: string,
        sortColumn:string,
        rerender1:boolean,
        totalCount: number
    }
    
    
    const initialProductcronjobsState: TProductcronjobsState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 1,
        searchTerm: "",
        loading: false,
        sortBy: "desc",
        sortColumn:"",
        rerender1:false,
        totalCount: 0
    
        
    }
    
    export const productcronjobsSlice = createSlice({
        name: 'productcronjobs',
        initialState:initialProductcronjobsState,
        reducers: {
            setProductcronjobs: (state:TProductcronjobsState, { payload }: PayloadAction<[]>) => {
              state.data=payload
             },
            setPerPage: (state:TProductcronjobsState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
            setTotalCount: (state:TProductcronjobsState, {payload}: PayloadAction<number>) => {
                state.totalCount = payload;
            },
            setCurrentPage: (state:TProductcronjobsState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:TProductcronjobsState, {payload}: PayloadAction<number>) => {
                state.totalPage = payload
             },
            setSearchTerm: (state:TProductcronjobsState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:TProductcronjobsState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:TProductcronjobsState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:TProductcronjobsState, {payload}: PayloadAction<boolean>) => { 
              state.loading = payload
            },
            setRerender: (state:TProductcronjobsState, {payload}: PayloadAction<boolean>) => {
                state.rerender1 = payload
             }
        },
    })
    
    
    export const { setProductcronjobs, setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading,setRerender , setTotalCount } = productcronjobsSlice.actions
    export default productcronjobsSlice.reducer
    